<template>
  <div class="more-tools">
    <div class="inner">
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/tool1.png" />
        </div>
        <div class="btn" @click="$emit('goEdit')">
          {{ $t("removeBackground") }}

          <img src="../../assets/images/icons/newhome/arrow_black.png" />
        </div>
      </div>
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/tool2.png" />
        </div>
        <div class="btn" @click="$emit('goEdit')">
          {{ $t("retouch") }}
          <img src="../../assets/images/icons/newhome/arrow_black.png" />
        </div>
      </div>
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/tool3.png" />
        </div>
        <div class="btn" @click="$emit('goEdit')">
          {{ $t("imageUpscaler") }}
          <img src="../../assets/images/icons/newhome/arrow_black.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoreTools",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.more-tools {
  .inner {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .child {
      flex: 1;
      margin: 0 9px;
      .img {
        height: 338px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .btn {
        justify-content: center;
        margin-top: 20px;
        font-size: 18px;
        font-family: GothamMedium;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s;
        display: flex;
        align-items: center;
        &:hover {
          opacity: 0.85;
        }
        img {
          height: 26px;
        }
      }
    }
  }
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .more-tools {
    .inner {
      width: 1200px;
    }
  }
}
</style>
